import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const resource = '/api/mia/guides';

const csrfToken = document.querySelector('[name=csrf-token]').content;

const model = abstractModel(resource);
const parentSave = model.save;
const parentGet = model.get;

model.get = async (params = {}, newResource = {}) => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const hasArrayParams = Object.values(params).some(value => Array.isArray(value));

    if (hasArrayParams) {
      const queryString = serializeParams(params);
      return parentGet({}, { ...newResource, filters: queryString });
    }
  }

  return parentGet(params, newResource);
};

model.optimize = async (instructions) => {
  const newResource = `${resource}/optimize`;

  return parentSave(
    { instructions: instructions },
    { path: newResource, csrfToken }
  );
};

model.scrape = async (url) => {
  const newResource = `${resource}/scrape`;

  return parentSave(
    url,
    { path: newResource }
  );
};

export default model;
